import { flow, identity } from 'fp-ts/function';
import { sortBy, toString } from 'lodash/fp';

import { memoizeWithResolver } from '../../../utils/func';
import { getHash } from '../../../utils/getHash';

const getStringHash = (obj: getHash.NotUndefined) => getHash(obj);

export const getIdsHash: (ids: string[]) => string = flow(sortBy(identity), getStringHash);

export const getMemoizedIdsHash: (ids: string[]) => string = flow(
    sortBy(identity),
    memoizeWithResolver(getHash, toString)
);
